// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__vqN+B","label":"Tooltip_label__dhYpi"};